module.exports = __webpack_public_path__ + "img/sdd_goals.85f2d252.png";